// AppAnalytics.js

const GA_MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-438JHY59RY';

function logAppPageView(pagePath) {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: document.title,
    page_location: window.location.href,
    send_to: GA_MEASUREMENT_ID,
  });
}

export {
  GA_MEASUREMENT_ID,
  logAppPageView,
};
